export default __webpack_public_path__ + "static/media/A2.880a7893.png";